import type { TCsvColumn, TCsvRow, TCsvValue } from './csv.types.ts';

const formulaPrefix = /^[=+\-@\t\r]/;
const quotedCharacters = /["\r\n]/;

export const columnsOf = <TRow extends TCsvRow>(
  rows: TRow[],
): TCsvColumn<TRow>[] => Object.keys(rows[0] ?? {}) as TCsvColumn<TRow>[];

export const toCsvText = (value: TCsvValue): string =>
  value === undefined || value === null ? '' : String(value);

export const escapeCsvCell = (
  value: TCsvValue,
  delimiter: string,
  escapeFormulas: boolean,
): string => {
  const text = toCsvText(value);
  const isFormula =
    escapeFormulas && typeof value === 'string' && formulaPrefix.test(text);

  const guarded = isFormula ? `'${text}` : text;
  const needsQuotes =
    isFormula || guarded.includes(delimiter) || quotedCharacters.test(guarded);

  if (!needsQuotes) {
    return guarded;
  }

  return `"${guarded.replace(/"/g, '""')}"`;
};

export const toCsvLine = (
  cells: TCsvValue[],
  delimiter: string,
  escapeFormulas: boolean,
): string =>
  cells
    .map((cell) => escapeCsvCell(cell, delimiter, escapeFormulas))
    .join(delimiter);
